import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import "@gjensidige/builders-components/dist/style.css";
import "@gjensidige/builders-fonts/dist/fonts.css";
import './index.scss';

import React from 'react';
import ReactDOM from "react-dom/client";
import { HashRouter } from 'react-router-dom';
import { ErrorPage } from '@gjensidige/se-error-page';
import {
  fetchGenericIllustrations,
  IllustrationType
} from '@gjensidige/se-content-helpers';
import { WebshopNavigation } from '@gjensidige/se-webshop-navigation';
import ErrorBoundary from '@gjensidige/service-error-boundary';
import { makeServer } from './mock-data/server.mock';
import {
  COMMON_ERROR_IMAGE,
  HEADER_CONSTANTS,
} from './lib/constants/appConstants';
import App from './App';
import { InsuranceHelper } from './utils/InsuranceHelper';
import { RoutingHelper } from './utils/RoutingHelper';
import { TextHelper } from './utils/TextHelper';
import { clientIdentification } from '@gjensidige/service-client-identification';
import packageJson from '../package.json';

if (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  !window.Cypress &&
  /* istanbul ignore next */ import.meta.env.MODE === 'development'
) {
  makeServer({ environment: 'development' });
}
const GjensidigeImgUrl =
  fetchGenericIllustrations('Gjensidige', IllustrationType.DETAILED, [
    {
      name: 'Gjensidige',
      filename: 'Gjensidige',
      fileType: 'svg'
    }
  ]) || '';
const channel = InsuranceHelper.getChannelInfo();
clientIdentification.configure({
  clientId: 'webshop-frontend-se',
  clientVersion: packageJson?.version || /* istanbul ignore next */ ''
});
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary
      errorComponent={function error() {
        return (
          <>
            <WebshopNavigation
              customerCareNumber={TextHelper.getCustomerCareNumber(
                channel.toLowerCase()
              )}
              openHours={HEADER_CONSTANTS.OPEN_HOURS}
              imageAlt={HEADER_CONSTANTS.IMAGE_ALT}
              imageSrc={GjensidigeImgUrl}
            />
            <ErrorPage
              headingText={'Hoppsan, något gick fel!'}
              descriptionText={
                'Hoppsan, vi verkar ha teknikstrul för tillfället! Vänligen försök lite senare eller <a target="_blank" href="https://www.gjensidige.se/privat/kundservice">kontakta kundservice</a>.'
              }
              primaryButtonLabel={'Gå tillbaka'}
              primaryBtnOnClick={() => {
                window.location.href = RoutingHelper.resolveFirstPageUrlPath(
                  RoutingHelper.getProductFromUrl()
                );
              }}
              imageSrc={COMMON_ERROR_IMAGE}
            />
          </>
        );
      }}
    >
      <HashRouter>
        <App />
      </HashRouter>
    </ErrorBoundary>
  </React.StrictMode>
)

